import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=640d0ae6&scoped=true"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&id=640d0ae6&prod&scoped=true&lang=scss"
import style1 from "./ProductManagement.vue?vue&type=style&index=1&id=640d0ae6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d0ae6",
  null
  
)

export default component.exports